import Resource from 'api/resource';
import http from 'utils/http';
class LocationNoAuthResource extends Resource {
  constructor() {
    super('jobsite-external-no-auth/');
  }
}

export { LocationNoAuthResource as default };
